// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"424b7dff","110":"f44bf409","295":"3d716659","412":"fc134df5","544":"d2773f49","665":"402736bf"}[chunkId] + ".chunk.js";
};